/* eslint-disable react/style-prop-object */
import './App.css';

import React, { useEffect, useState, useRef } from 'react';
import ReactTooltip from 'react-tooltip';
import { useTranslation, Trans } from 'react-i18next';
import { IntlProvider } from 'react-intl';
import $ from 'jquery';
import Modal from 'react-modal';
import ImageGallery from 'react-image-gallery';
import {decodeHtmlCharCodes} from './helpers/textHelper';

import subaruimg from './images/subaru.png';
import adventureon from './images/adventureon.png';
import adventureonfr from './images/adventureon_fr.png';
import cannondale from './images/Cannondale Logo.png';
import chillymoose from './images/ChillyMoose-logo.png';
import thule from './images/Thule-logo.png';
import bgimage2 from './images/sect2bg.png';
import subarufooter from './images/subaru_footer.png';

import polaroid1 from './images/Polaroid1_EN.png';
import polaroid2 from './images/Polaroid2_EN.png';
import polaroid3 from './images/Polaroid3_EN.png';
import polaroid1_fr from './images/Polaroid1_FR.png';
import polaroid2_fr from './images/Polaroid2_FR.png';
import polaroid3_fr from './images/Polaroid3_FR.png';

import Icon from './components/Icons/Icon';

import ContactUs from './components/modals/ContactUs';
import PhotoRequirements from './components/modals/PhotoRequirements';
import TermsConditions from './components/modals/TermsConditions';
import Rules from './components/modals/Rules';
import colours from './Colours';
import { useLocation, useNavigate } from 'react-router-dom';
import winners from './winners';
import ic_user from './images/ic-user.svg';
import ic_pin from './images/ic-pin.svg';

import provinceparks from './images/Parks.png';
import bgimage3mobile from './images/bg-image-3_mobile.png';
import polaroid_grand from './images/polaroid_grand.png';
import polaroid_grand_fr from './images/polaroid_grand_fr.png';
import polaroid_second from './images/polaroid_second.png';
import polaroid_second_fr from './images/polaroid_second_fr.png';
import polaroid_third from './images/polaroid_third.png';
import polaroid_third_fr from './images/polaroid_third_fr.png';

const App = () => {
  let APP_URL = window.location.hostname;

  if (APP_URL.includes('www.'))
    APP_URL = APP_URL.slice(4, undefined);

  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(()=> {
    setShowContactUs(location.pathname.includes('/contact'));
    setShowTC(location.pathname.includes('/terms'));
    setShowTU(location.pathname.includes('/rules') || location.pathname.includes('/r%C3%A8gles') || location.pathname.includes('/règles')  || location.pathname.includes('/regles'));
    setShowPR(location.pathname.includes('/photorequirements'));
  }, [location.pathname])

  const [showContactUs, setShowContactUs] = useState(false);
  const [showTC, setShowTC] = useState(false);
  const [showPR, setShowPR] = useState(false);
  const [showTCForAccept, setShowTCForAccept] = useState(false);
  const [showTU, setShowTU] = useState(false);
  const [showGallery, setShowGallery] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [images, setImages] = useState([]); //18 total images required
  const galleryRef = useRef();
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [promotedPage, setPromotedPage] = useState(3);
  const [inspirationGalleryImages, setInspirationGalleryImages] = useState([]);

  const fetchPromotedPage = (page) => {
    if (page !== -1) {
      fetch(`https://api.${APP_URL}/api/v1/promoted-images?page=${page}`)
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        if (res.data && (page !== -1)) {
          const images = res.data.map((img) => ({
            name: img.initials,
            location: img.location,
            description: img.description,
            original: img.blobs[0].cdnUrl,
            thumbnail: img.blobs[1].cdnUrl,
            place: -1
          }))

          if (inspirationGalleryImages.length < 18) {
            setInspirationGalleryImages((prev) => [...prev, ...images]);
          }

          winners.push(...images);
          if (res.data.length < 10) {
            setPromotedPage(-1);
          } else {
            setPromotedPage(page + 1);
          }
        }
      })
      .catch((err) => {
        console.error(`[fetchPromotedPage page ${page}] Something went wrong...`);
        // setPromotedPage(-1);
      })
    }
  };

  const fetchInitialPromotedPages = () => {
    fetch(`https://api.${APP_URL}/api/v1/promoted-images?page=1`)
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        if (res.data && (promotedPage !== -1)) {
          winners.push(...res.data.map((img) => ({
            name: img.initials,
            location: img.location,
            description: img.description,
            original: img.blobs[0].cdnUrl,
            thumbnail: img.blobs[1].cdnUrl,
            place: -1
          })));
          if (res.data.length < 10) {
            setPromotedPage(-1);
          } else {
            setPromotedPage(promotedPage + 1);
          }
          fetch(`https://api.${APP_URL}/api/v1/promoted-images?page=2`)
            .then((res) => {
              return res.json();
            })
            .then((res2) => {
              if (res2.data && (promotedPage !== -1)) {
                winners.push(...res2.data.map((img) => ({
                  name: img.initials,
                  location: img.location,
                  description: img.description,
                  original: img.blobs[0].cdnUrl,
                  thumbnail: img.blobs[1].cdnUrl,
                  place: '-1'
                })));
                if (res2.data.length < 10) {
                  setPromotedPage(-1);
                } else {
                  setPromotedPage(promotedPage + 1);
                }
              }
            })
            .catch((err) => {
              console.error('[fetchInitialPromotedPages page 2] Something went wrong...');
              // setPromotedPage(-1);
            })
        }
      })
      .catch((err) => {
        console.error('[fetchInitialPromotedPages page 1] Something went wrong...');
        // setPromotedPage(-1);
      })
  }

  useEffect(()=> {
    onResize();
    window.addEventListener('resize', onResize);
    setImages(winners);

    fetchInitialPromotedPages();
    fetchInspirationGalleryImages();
    ReactTooltip.rebuild();

    return (()=> {
      window.removeEventListener('resize', onResize);
    })
  }, [])

  const onResize = () => {
    setScreenWidth(window.innerWidth);
    let vh = document.documentElement.clientHeight * 0.01;
    // eslint-disable-next-line no-restricted-globals
    let sh = screen.height;

    if (vh > sh) {
      document.documentElement.style.setProperty('--vh', `${sh}px`);
    } else {
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
  }

  useEffect(() => {
    if ((currentIndex + 6) >= winners?.length) {
      fetchPromotedPage(promotedPage);
    }
  }, [currentIndex])

  function openGallery(index=-1) {
    setCurrentIndex(index);
    setShowGallery(true);
  }

  useEffect(()=>{
    if (window.location && (window.location.href.includes('concoursenavantlaventure') || window.location.href.includes('ca-fr'))) {
      i18n.changeLanguage('fr');
    } else {
      i18n.changeLanguage('en');
    }
  },[i18n])

  var lazyloadImages;

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          image.src = image.dataset.src;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {  
    var lazyloadThrottleTimeout;
    lazyloadImages = $(".lazy");
    
    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }    

      lazyloadThrottleTimeout = setTimeout(function() {
          var scrollTop = $(window).scrollTop();
          lazyloadImages.each(function() {
              var el = $(this);
              if(el.offset().top - scrollTop < window.innerHeight) {
                var url = el.attr("data-src");
                el.attr("src", url);
                el.removeClass("lazy");
                lazyloadImages = $(".lazy");
              }
          });
          if(lazyloadImages.length === 0) { 
            $('app-container').off("scroll");
            $(window).off("resize");
          }
      }, 20);
    }

    $('app-container').on("scroll", lazyload);
    $(window).on("resize", lazyload);
  }

  const fetchInspirationGalleryImages = () => {
    fetchPromotedPage(3);
    fetchPromotedPage(4);
  }

  const renderInspirationGallery = () => {
    // const filteredWinners = winners.filter((winner) => winner.place === '-1');
    // const images = filteredWinners?.length ? filteredWinners : winners;
    const images = inspirationGalleryImages?.length ? inspirationGalleryImages : winners;

    return (
      <div style={{display: 'flex', flex: 1, flexDirection: 'row', width: '100%', marginBottom: 8, overflowX: 'auto'}}>
        <div style={{padding: '8px 12px', display: 'flex'}}>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
                <div className="gallery-item-lg" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[0].thumbnail))}>
                    <img src={images[0]?.thumbnail} alt="Image1" className="gallery-item-lg-image"/>
                </div>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[1].thumbnail))}>
                        <img src={images[1]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[2].thumbnail))}>
                        <img src={images[2]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[3].thumbnail))}>
                        <img src={images[3]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                </div>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[4].thumbnail))}>
                        <img src={images[4]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                </div>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[5].thumbnail))}>
                        <img src={images[5]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[6].thumbnail))}>
                        <img src={images[6]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[7].thumbnail))}>
                        <img src={images[7]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                </div>
                <div className="gallery-item-lg" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[8].thumbnail))}>
                    <img src={images[8]?.thumbnail} alt="Image1" className="gallery-item-lg-image"/>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[9].thumbnail))}>
                        <img src={images[9]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[10].thumbnail))}>
                        <img src={images[10]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[11].thumbnail))}>
                        <img src={images[11]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                </div>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[12].thumbnail))}>
                        <img src={images[12]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[13].thumbnail))}>
                        <img src={images[13]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[14].thumbnail))}>
                        <img src={images[14]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                </div>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[15].thumbnail))}>
                        <img src={images[15]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[16].thumbnail))}>
                        <img src={images[16]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                    <div className="gallery-item-sm" onClick={()=>openGallery(winners.findIndex((item) => item.thumbnail === images[17].thumbnail))}>
                        <img src={images[17]?.thumbnail} alt="Image1" className="gallery-item-sm-image"/>
                    </div>
                </div>
            </div>
        </div>
      </div>
    )
  }
  
  return (
    <IntlProvider locale={i18n.language}>
      <div>
        <div id="app-container" className={"app-container" + ((showTU || showContactUs || showTC) ? " modal-open" : "")}>
          <div className="header-container">
            <div className="inner-header-container">
              <div className="header-image-container">
                <div className="subaru-logo-container" style={{cursor: 'pointer'}} onClick={()=> {i18n.language === 'fr' ? window.open('https://www.subaru.ca/WebPage.aspx?WebSiteID=284') : window.open('https://www.subaru.ca/WebPage.aspx?WebSiteID=282')}}>
                  <img src={subaruimg} alt="Subaru Logo" className="subaru-logo"/>
                </div>
              </div>
              <div className="header">
                {/* <a href="#claim-parks-pass">
                  <div className="header-button hide-mobile">
                    <Trans>Submit Your Photo</Trans>
                  </div>
                </a> */}
                <div className="header-button hide-mobile" onClick={()=>{navigate('/contact')}}>
                  <Trans>Contact Us</Trans>
                </div>
                <div className="header-button hide-mobile" onClick={()=>{i18n.language === 'fr' ? window.open('https://www.subaru.ca/WebPage.aspx?WebSiteID=284&WebPageID=23930&Range=Outback&ModelYear=2022') : window.open('https://www.subaru.ca/WebPage.aspx?WebPageID=23929')}}>
                  <Trans>2022 Outback Wilderness</Trans>
                </div>
                <div style={{marginLeft: 16}}>
                  <Icon name="Globe" size={24} style={{color: 'white'}}/>
                </div>
                <div className={"header-button language-select" + (i18n.language === 'en' ? ' active' : '')} onClick={()=>{i18n.changeLanguage('en')}}>
                  EN
                </div>
                <div className={"header-button language-select" + (i18n.language === 'fr' ? ' active' : '')} onClick={()=>{i18n.changeLanguage('fr')}} style={{marginRight: 8}}>
                  FR
                </div>
              </div>
            </div>
          </div>
          <div className="body-container">
            <div className="outer-body-container">
              <div className="inner-body-container">
                <div className="body-section-container section-one">
                  <div className="body-section section-one-background">
                    <div className="body-row" style={{justifyContent: 'space-between'}}>
                      <div className="h1-text and-the-winners-are-container">
                        <div className='and-the-winners-are' style={screenWidth >= 1152 ? {maxWidth: 497} : {justifyContent: 'center', display: 'flex', flex: 1, flexDirection: 'row'}}><Trans>And the Winners Are...</Trans></div>
                        <div className="body-row P2 section-one-paragraph" style={{fontSize: i18n.language === 'fr' ? '14px' : undefined}}>
                          <div className='m-polaroid-adventure-on-header'>
                            <img src={i18n.language === 'fr' ? adventureonfr : adventureon} alt="Adventure On" className="adventure-on-logo"/>
                            <div id="polaroid3" className="polaroid">
                              <img src={i18n.language === 'fr' ? polaroid3_fr : polaroid3} alt="polaroid3"/>
                            </div>
                            <div id="polaroid2" className="polaroid">
                              <img src={i18n.language === 'fr' ? polaroid2_fr : polaroid2} alt="polaroid2"/>
                            </div>
                            <div id="polaroid1" className="polaroid">
                              <img src={i18n.language === 'fr' ? polaroid1_fr : polaroid1} alt="polaroid1"/>
                            </div>
                          </div>
                          <div className='section-one-text' style={ screenWidth >= 1152 ? {maxWidth: 760, marginRight: 8} : {padding: '0 16px'}}>
                            <Trans i18nKey='contest-hero-section-one-text'>Subaru Canada would like to congratulate the winners of the 2022 Adventure on Parks contest! Your photos truly embodied the adventure on spirit.<br/><br/>Thank you to everyone who participated for sharing your outdoor adventures with us. We hope you continue to visit and explore Canada’s stunning parks and outdoor wilderness.</Trans>
                          </div>
                        </div>
                        <div className="body-row P2" style={{justifyContent: 'center', marginTop: 8, color: '#FFF', fontFamily: 'Lato'}}>
                          <Trans>In partnership with</Trans>:
                        </div>
                        <div className="body-row" style={{justifyContent: 'center', marginTop: 8, color: '#FFF'}}>
                          <div style={{maxHeight: 64, maxWidth: 340, display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
                            <div style={{cursor: 'pointer'}} onClick={()=> {window.open('https://www.cannondale.com/en-ca')}}>
                              <img src={cannondale} alt="sticker" style={{display: 'flex'}}/>
                            </div>
                            <div style={{cursor: 'pointer'}} onClick={()=> {window.open('https://www.thule.com/en-ca')}}>
                              <img src={thule} alt="sticker" style={{display: 'flex'}}/>
                            </div>
                            <div style={{cursor: 'pointer'}} onClick={()=> {window.open('https://www.chillymoose.ca')}}>
                              <img src={chillymoose} alt="sticker" style={{display: 'flex'}}/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='polaroid-adventure-on-header'>
                        <img src={i18n.language === 'fr' ? adventureonfr : adventureon} alt="Adventure On" className="adventure-on-logo"/>
                        <div id="polaroid3" className="polaroid">
                          <img src={i18n.language === 'fr' ? polaroid3_fr : polaroid3} alt="polaroid3"/>
                        </div>
                        <div id="polaroid2" className="polaroid">
                          <img src={i18n.language === 'fr' ? polaroid2_fr : polaroid2} alt="polaroid2"/>
                        </div>
                        <div id="polaroid1" className="polaroid">
                          <img src={i18n.language === 'fr' ? polaroid1_fr : polaroid1} alt="polaroid1"/>
                        </div>
                      </div>
                    </div>
                    {/* <div className="m-polaroids-container">
                      <div id="m-polaroid1" className={"polaroid" + (screenWidth <= 400 ? screenWidth < 350 ? " xs" : " s" : "")}>
                        <img src={i18n.language === 'fr' ? polaroid3_fr : polaroid3} alt="polaroid1"/>
                      </div>
                      <div id="m-polaroid2" className={"polaroid" + (screenWidth <= 400 ? screenWidth < 350 ? " xs" : " s" : "")}>
                        <img src={i18n.language === 'fr' ? polaroid4_fr : polaroid4} alt="polaroid4"/>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="body-section-container section-two-container" style={{minHeight: 'unset', backgroundImage: "url(" + bgimage2 + ")", overflow: 'visible'}} id="claim-parks-pass">
                  <div className="body-section section-two-background" style={{borderRadius: 4, width: '100%'}}>
                    <div className="body-row section-two-header-row" style={{justifyContent: 'center'}}>
                      <div className="section-two-header-text">
                        <div className="prize-winner-badge-container first-prize P3">
                          <Icon name="Prize" size={54} style={{marginRight: 8, background: '#F4F5F6', borderRadius: '56px', color: colours.primary}}/>
                          <Trans>Grand Prize Winner</Trans>
                        </div>
                      </div>
                    </div>
                    <div className="body-row section-two-header-row" style={{justifyContent: 'center'}}>
                      <div className='prize-winner-section-grid-container grand-prize-section'>
                      {
                          winners.filter(winner => winner.place === '1').map((winner, index) => {
                            // let [filename, extension] = fileNameAndExt(winner.url);
                            return (
                              <div className='winner-container' key={index}>
                                <img className='winner-img winner-img-first lazy' src={winner.thumbnail} data-src={winner.original} alt={winner.name} style={{width: 346, height: 346, objectFit: 'cover'}} onClick={()=>openGallery(parseInt(winner.index))}/>
                                <div className='winner-name'>
                                  <img className='ic-user' src={ic_user} alt='User Icon' style={{width: 24, height: 24}}/>
                                  {winner.name}
                                </div>
                                <div className='winner-location'>
                                  <img className='ic-pin' src={ic_pin} alt='Location Icon' style={{width: 24, height: 24}}/>
                                  {winner.location}
                                </div>
                              </div>
                            )
                          })
                        }
                        <div className="polaroid-winner grand-winner" style={{transform: 'translate(0px, -28px)'}}>
                          <img src={i18n.language === 'fr' ? polaroid_grand_fr : polaroid_grand} alt="polaroid"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="body-section-container section-two-container" style={{minHeight: 'unset', backgroundImage: "url(" + bgimage2 + ")", overflow: 'visible'}} id="claim-parks-pass">
                  <div className="body-section section-two-background" style={{borderRadius: 4, width: '100%'}}>
                    <div className="body-row section-two-header-row" style={{justifyContent: 'center'}}>
                      <div className="section-two-header-text">
                        <div className="prize-winner-badge-container second-prize P3">
                          <Icon name="Prize" size={54} style={{marginRight: 8, background: '#F4F5F6', borderRadius: '56px', color: colours.primary}}/>
                          <Trans>Second Prize Winners</Trans>
                        </div>
                      </div>
                    </div> 
                    <div className="body-row section-two-header-row" style={{justifyContent: 'center'}}>
                      <div className='prize-winner-section-grid-container second-prize-section'>
                      {
                          winners.filter(winner => winner.place === '2').map((winner, index) => {
                            return (
                              <div className='winner-container' key={index}>
                                <img className='winner-img lazy' src={winner.thumbnail} alt={winner.name} data-src={winner.original} style={{width: 260, height: 260}} onClick={()=>openGallery(parseInt(winner.index))}/>
                                <div className='winner-name'>
                                  <img className='ic-user' src={ic_user} alt='User Icon' style={{width: 24, height: 24}}/>
                                  {winner.name}
                                </div>
                                <div className='winner-location'>
                                  <img className='ic-pin' src={ic_pin} alt='Location Icon' style={{width: 24, height: 24}}/>
                                  {winner.location}
                                </div>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                    <div className="body-row section-two-header-row" style={{justifyContent: 'center', flex: 1}}>
                      <div className="polaroid-winner" style={{justifyContent: 'center'}}>
                        <img src={i18n.language === 'fr' ? polaroid_second_fr : polaroid_second} alt="polaroid"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="body-section-container section-two-container" style={{minHeight: 'unset', backgroundImage: "url(" + bgimage2 + ")", overflow: 'visible'}} id="claim-parks-pass">
                  <div className="body-section section-two-background" style={{borderRadius: 4, width: '100%'}}>
                    <div className="body-row section-two-header-row" style={{justifyContent: 'center'}}>
                      <div className="section-two-header-text">
                        <div className="prize-winner-badge-container third-prize P3">
                          <Icon name="Prize" size={54} style={{marginRight: 8, background: '#F4F5F6', borderRadius: '56px', color: colours.primary}}/>
                          <Trans>Third Prize Winners</Trans>
                        </div>
                      </div>
                    </div>
                    <div className="body-row section-two-header-row" style={{justifyContent: 'center'}}>
                      <div className='prize-winner-section-grid-container third-prize-section'>
                        {
                          winners.filter(winner => winner.place === '3').map((winner, index) => {
                            return (
                              <div className='winner-container' key={index}>
                                <img 
                                  className='winner-img lazy'
                                  src={winner.thumbnail}
                                  data-src={winner.original}
                                  alt={winner.name} 
                                  style={{width: 260, height: 260}}
                                  onClick={()=>openGallery(parseInt(winner.index))}/>
                                <div className='winner-name'>
                                  <img className='ic-user' src={ic_user} alt='User Icon' style={{width: 24, height: 24}}/>
                                  {winner.name}
                                </div>
                                <div className='winner-location'>
                                  <img className='ic-pin' src={ic_pin} alt='Location Icon' style={{width: 24, height: 24}}/>
                                  {winner.location}
                                </div>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                    <div className="body-row section-two-header-row" style={{justifyContent: 'center', flex: 1}}>
                      <div className="polaroid-winner" style={{justifyContent: 'center'}}>
                        <img src={i18n.language === 'fr' ? polaroid_third_fr : polaroid_third} alt="polaroid"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="body-section-container">
                  <div className="body-section section-two-background">
                    <div className="body-row section-three-header-row">
                      <div className="section-four-header-text" style={{textAlign: 'center', minWidth: '100%', marginLeft: 0}}>
                        <Trans>Contest Entries</Trans>
                      </div>
                      {renderInspirationGallery()}
                    </div>
                  </div>
                </div>
                <div className="body-section-container section-three">
                  <img className='show-mobile mobile-sec3-bg' src={bgimage3mobile} alt="2022 Outback Wilderness, 2022 Forester Wilderness"/>
                  <div className="body-section section-three-background">
                    <div className="body-row section-three-header-row" style={{alignItems: 'center'}}>
                      <div className="section-three-header-text" style={{color: 'white'}}>
                        <Trans>Proud supporter of Parks across Canada</Trans>
                      </div>
                    </div>
                    <div className="body-row section-three-parks-overlay-container">
                      <div className="section-three-parks-overlay">
                        <img src={provinceparks} alt="BC Parks, Parks New Brunswick, Ontario Parks"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="body-section-container" style={{backgroundColor: '#FFFFFF', marginBottom: 8, height: 260}} id="contact-us">
                  <div className="body-section" style={{flex: 1, justifySelf: 'center'}}>
                    <div className="body-row H5" style={{marginTop: 48, justifyContent: 'center'}}>
                      <Trans>Connect with us</Trans>
                    </div>
                    <div className="body-row" style={{marginTop: 16, justifyContent: 'center'}}>
                      <div className="P3" style={{width: 564, textAlign: 'center'}}>
                        <Trans>
                          If you have any questions regarding the Subaru Canada Adventure On Contest, connect with us here and we will get you back on track.
                        </Trans>
                      </div>
                    </div>
                    <div className="body-row" style={{marginTop: 32, marginBottom: 32, justifyContent: 'center'}}>
                      <div className="secondary-button" onClick={()=>{navigate('/contact')}}>
                        <Icon name="Contact" size={20} style={{marginRight: 10}}/>
                        <Trans>Contact Form</Trans>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer style={{ backgroundColor: '#7E7E7E', padding: '20px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '6px' }}>
              <img src={subarufooter} alt="Subaru" style={{height: 50}}/>
              <a href="/privacy">
                Privacy Policy
              </a>
            </div>
          </footer>
        </div>
        <ReactTooltip className="tooltip" effect="solid" type="light"/>
        <ContactUs 
          isOpen={showContactUs} 
          closeModal={()=> {
            setShowContactUs(false);
            navigate('/');
          }}/>
        <TermsConditions 
          isOpen={showTC} 
          closeModal={()=>{
            setShowTC(false); 
            navigate('/');
          }}/>
        <TermsConditions 
          isOpen={showTCForAccept} 
          closeModal={()=>{
            setShowTCForAccept(false); 
            navigate('/');
          }} 
          onAccept={()=>{
            setShowTCForAccept(false); 
            navigate('/');
          }}/>
        <Rules 
          isOpen={showTU} 
          closeModal={()=>{
            setShowTU(false);
            navigate('/');
          }}/>
        <PhotoRequirements 
          isOpen={showPR} 
          closeModal={()=>{
            setShowPR(false);
            navigate('/');
          }}/>
          <Modal
                isOpen={showGallery}
                onRequestClose={()=>{setShowGallery(false)}}
                style={{
                    content: {
                        background: '#000'
                    }
                }}
            >
                <ImageGallery 
                    items={winners}
                    additionalClass="gallery-container" 
                    ref={galleryRef} 
                    lazyLoad
                    startIndex={currentIndex} 
                    slideDuration={300} 
                    onSlide={setCurrentIndex}
                    renderPlayPauseButton={()=> {
                        return (
                          <div className='gallery-custom-container'>
                            <div className="gallery-location-text">
                                <Icon name="Pin" className="shadowed"/>
                                {decodeHtmlCharCodes(images[currentIndex]?.location)}
                            </div>
                            {
                              winners[currentIndex]?.place === '1'
                              ? <div className="section-two-header-text">
                                  <div className="prize-winner-badge-container first-prize P3">
                                    <Icon name="Prize" size={36} style={{marginRight: 8, background: '#F4F5F6', borderRadius: '56px', color: colours.primary}}/>
                                    <Trans>Grand Prize Winner</Trans>
                                  </div> 
                                </div>
                              : winners[currentIndex]?.place === '2'
                              ? <div className="section-two-header-text">
                                  <div className="prize-winner-badge-container second-prize P3">
                                    <Icon name="Prize" size={36} style={{marginRight: 8, background: '#F4F5F6', borderRadius: '56px', color: colours.primary}}/>
                                    <Trans>Second Prize Winner</Trans>
                                  </div> 
                                </div>
                              : winners[currentIndex]?.place === '3'
                              ? <div className="section-two-header-text">
                                  <div className="prize-winner-badge-container third-prize P3">
                                    <Icon name="Prize" size={36} style={{marginRight: 8, background: '#F4F5F6', borderRadius: '56px', color: colours.primary}}/>
                                    <Trans>Third Prize Winner</Trans>
                                  </div> 
                                </div>
                              : null
                            }
                          </div>
                        )
                    }}
                />
                
                <div className='gallery-close' onClick={()=>{setShowGallery(false)}}>
                    <Icon name="Close" size={32} className="shadowed"/>
                </div>
            </Modal>
      </div>
    </IntlProvider>
  );
}

export default App;
